import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import MainMenu from 'src/components/containers/main-menu';
import { Button, Card, Icon, Layout, Link, Page, TextStyle, Tooltip } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';
import { MobileCancelMajor, LockMinor, ExternalSmallMinor } from '@shopify/polaris-icons';
import { connect } from 'react-redux';
import SearchControlTable from 'src/components/views/search-control/search-control-table';
import TitleHelp from 'src/components/views/common/title-help';
import SearchPersonalizationPresentBanner from 'src/components/views/advanced-search/search-personalization-present-banner';
import MarketingCampaignBanner from 'src/components/views/common/marketingCampaignBanner';
import EnhanceAISearchBanner from 'src/components/views/advanced-search/enhance-ai-search-banner';
import ChangePlanFromReviewIOModal from 'src/components/views/common/change-plan-from-reviewio-modal';
import { URL } from 'src/constants/links';
import { routes } from 'src/routes';
import { getShop } from 'src/helpers';
import history from 'src/routes/history';
import testSearchIcon from 'src/assets/images/common/test-search-icon.png';
import searchControlBannerLock from 'src/assets/images/lock-unlock-image/search-control-banner-lock.svg';
import rocketIcon from 'assets/images/common/rocket-icon.png';

const SearchControl = props => {
  const { i18n, selectedPlan, useBoltOn } = props;
  const [active, setActive] = useState(true);
  const [changePlanFromReviewIOModal, setChangePlanFromReviewIOModal] = useState(false);

  useEffect(() => {
    // Check show info banner
    let dismiss = false;
    try {
      dismiss = localStorage.getItem(`${getShop()}-dismissSearchControlLockBanner`);
    } catch (error) {}

    // If the banner is dismissed, hide it
    if (dismiss === 'true') {
      setActive(false);
    }
  }, []);

  // Handle dismiss info banner
  const onDismiss = () => {
    try {
      localStorage.setItem(`${getShop()}-dismissSearchControlLockBanner`, true);
    } catch (error) {}
    setActive(false);
  };

  return (
    <div className="BC-Page BC-Page__SearchControl">
      <MainMenu menuId="menu-search-search-control" />
      <Page
        title={
          <div className="page-title-wrapper">
            <h1 className="Polaris-Header-Title Polaris-Header-Title__TitleWithSubtitle">
              {i18n.translate('AdminHTML.SearchControl.SearchControl.title')}
            </h1>
          </div>
        }>
        <div className="sub-title">
          <TitleHelp i18n={i18n} hrefUserManual={URL.Search_Site_Search_Algorithm} />
          <Tooltip
            content={i18n.translate('AdminHTML.TestYourSearch.TestYourSearch.tooltip')}
            preferredPosition="above">
            <p onClick={() => history.push(routes.testYourSearch.view())}>
              <img width={16} height={16} src={testSearchIcon} alt="pfs-test-search-icon" />
              {i18n.translate('AdminHTML.TestYourSearch.TestYourSearch.title')}
            </p>
          </Tooltip>
        </div>
        {selectedPlan.includes('freemium') && active && (
          <div className="search-control-lock-banner">
            <div className="title">
              <img src={rocketIcon} alt="pfs-rocket-icon" width={24} height={24} />
              {i18n.translate('AdminHTML.SearchControl.Plan.banner_Title')}
            </div>
            <Button onClick={onDismiss} icon={MobileCancelMajor} plain />
            <div className="body">
              <div className="paragraph">
                <div className="content">
                  <p>
                    {i18n.translate('AdminHTML.SearchControl.Plan.banner_Content01', {
                      t: (
                        <TextStyle variation="strong">
                          {i18n.translate('AdminHTML.SearchControl.Plan.banner_Content01_t')}
                        </TextStyle>
                      )
                    })}
                  </p>
                  <p>
                    {i18n.translate('AdminHTML.SearchControl.Plan.banner_Content02', {
                      t: (
                        <TextStyle variation="strong">
                          {i18n.translate('AdminHTML.SearchControl.Plan.banner_Content02_t')}
                        </TextStyle>
                      )
                    })}
                  </p>
                  <p>{i18n.translate('AdminHTML.SearchControl.Plan.banner_Content03')}</p>
                </div>
                <div className="action">
                  <div
                    className={`Polaris-Button`}
                    onClick={() =>
                      useBoltOn
                        ? setChangePlanFromReviewIOModal(true)
                        : history.push(routes.subscription.package())
                    }>
                    <Icon source={LockMinor} />
                    {i18n.translate(`AdminHTML.SearchControl.Plan.banner_Action01`)}
                  </div>
                  <Link external url={URL['Search_Site_Search_Algorithm']}>
                    {i18n.translate('AdminHTML.Common.Action.learnMore')}
                    <Icon source={ExternalSmallMinor}></Icon>
                  </Link>
                </div>
              </div>
              <div className="image">
                <img src={searchControlBannerLock} alt="search-control-lock" />
              </div>
            </div>
          </div>
        )}
        <div className="layout-wrapper">
          <Layout>
            <Layout.Section>
              <div className="BC-Container__Notifications">
                {!selectedPlan.includes('freemium') && (
                  <MarketingCampaignBanner
                    page="SearchControl"
                    type="horizontal"
                    showWhenDismissed={
                      <SearchPersonalizationPresentBanner
                        type="horizontal"
                        page="SearchControl"
                        showWhenDismissed={<EnhanceAISearchBanner />}
                      />
                    }
                  />
                )}
              </div>
            </Layout.Section>
            <Layout.Section>
              <div className="BC-Page SearchControl__Content BC-Page__Fields">
                <Card sectioned>
                  <span>{i18n.translate('AdminHTML.SearchControl.Table.description')}</span>
                  <SearchControlTable />
                </Card>
              </div>
            </Layout.Section>
          </Layout>
        </div>
      </Page>
      <ChangePlanFromReviewIOModal
        open={changePlanFromReviewIOModal}
        onClose={() => setChangePlanFromReviewIOModal(false)}
      />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    useBoltOn: _.get(state.oauth, 'subscription.useBoltOn', false),
    selectedPlan: _.get(state.oauth.tenantApp, 'selectedPlan', ''),
    enableNewSearch: _.get(state.oauth, 'tenantApp.settings.instantSearch.settings.enable', false)
  };
};

export default withI18n()(connect(mapStateToProps, null)(SearchControl));
